export const getImageSrcFromBase64 = (base64: string, photoUrl: string) =>
  (base64 ? `data:image/*;base64,${base64}` : photoUrl)
